var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('section',{staticClass:"g-cats"},_vm._l((_vm.subcategoriesIntern),function(category,index){return _c('category-item',{key:index,attrs:{"category":category}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }